import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';
import { CompanyData } from '../../../types/company-data';
import { User } from '../../../types/user';

export abstract class MyCompanyPanelBaseDataProvider extends BaseWebComponentDataProvider {
  public abstract getMyCompanyData(): Promise<CompanyData>;

  public abstract getLoggedUser(): Promise<User>;
}
